import { render, staticRenderFns } from "./dxy-modal.vue?vue&type=template&id=3f924b7e&"
import script from "./dxy-modal.vue?vue&type=script&lang=js&"
export * from "./dxy-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dxy-modal.vue"
export default component.exports